export default "__VITE_ASSET__Bidh27mx__"